module.exports = __webpack_public_path__ + "img/top.05eda464.jpg";